import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	ExportTransactionsResponse,
	SharesTransactionsFiltersResponse,
	SharesTransactionsPayload,
	SharesTransactionsResponse,
	TransferSettings,
	LimitsTransferSettings,
	ActivationTransferSettings,
	TransferApprovalsResponse,
	RejectApprovalPayload,
} from '../models/transaction';

export const onGetSharesTransactions = async (payload: SharesTransactionsPayload) => {
	try {
		const response = await axios.get<JsonResponse<SharesTransactionsResponse>>('dashboard/share-transactions', {
			params: { ...payload },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetSharesTransactionsFilter = async () => {
	try {
		const response = await axios.get<JsonResponse<SharesTransactionsFiltersResponse>>('dashboard/share-transactions/filter-options');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onExportSharesTransactions = async (payload: SharesTransactionsPayload) => {
	try {
		const response = await axios.get<JsonResponse<ExportTransactionsResponse | null>>(`dashboard/share-transactions/export`, {
			params: { ...payload },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetTransferSettings = async () => {
	try {
		const response = await axios.get<JsonResponse<TransferSettings>>('dashboard/transfer-settings');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateLimitationTransferSettings = async (payload: LimitsTransferSettings) => {
	try {
		const response = await axios.put<JsonResponse<TransferSettings>>('dashboard/transfer-settings/limits', payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onUpdateActivationTransferSettings = async (payload: ActivationTransferSettings) => {
	try {
		const response = await axios.put<JsonResponse<TransferSettings>>('dashboard/transfer-settings/controls', payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetTransferApprovals = async (page?: number, status?: string) => {
	try {
		const response = await axios.get<JsonResponse<TransferApprovalsResponse>>('dashboard/transfer-approvals/history', {
			params: { page, status: status || undefined },
		});
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onApproveTransfer = async (id: number) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/transfer-approvals/${id}/approve`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onRejectTransfer = async (id: number, payload: RejectApprovalPayload) => {
	try {
		const response = await axios.post<JsonResponse<any>>(`dashboard/transfer-approvals/${id}/reject`, payload);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetTransferApprovalsCount = async () => {
	try {
		const response = await axios.get<JsonResponse<{ pending_count: number }>>('dashboard/transfer-approvals/count');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
